import moment from "moment";

import { AccountBasicStore, AccountStore } from "./types";

export const defaultState: AccountStore = {
  account: {
    marketing: {
      offersOptIn: false,
    },
    source: {
      id: 104,
      name: "",
    },
    type: {
      id: 5,
      name: "",
    },
  },
  loading: false,
  token: undefined,
};

/**
 * Replaces the MM/DD/YYYY date in a lead's task title and description
 * with the date derived from the given YYYY-MM-DD string.
 * Returns only the fields that have a value to update.
 */
export const buildLeadTaskUpdate = (
  lead: AccountStore["lead"],
  date: string, // YYYY-MM-DD
): { title?: string; description?: string } => {
  if (!lead) return {};
  const newDate = moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
  return {
    ...(lead.title && {
      title: lead.title.replace(/\d{2}\/\d{2}\/\d{4}/g, newDate),
    }),
    ...(lead.description && {
      description: lead.description.replace(/\d{2}\/\d{2}\/\d{4}/g, newDate),
    }),
  };
};

export const defaultBasicState: AccountBasicStore = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  billingAddress: undefined,
};
